import api from '@gnb/api/common'
import { ActionTree } from 'vuex';
import * as types from './types';
import { i18n, IEDate } from '@appbase/util';
import store from '@/store';

import { WisenutSearch } from '@appbase/util/wisenut-search'

export default <ActionTree<gnb.state.GnbState, RootState>>{
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 로딩 UI를 호출합니다
     * @param action 
     * @param flag 
     */
     [types.COMMON_LOADDING](action, flag: boolean) {
        action.commit(types.COMMON_LOADDING, flag);        
    },

    [types.COMPANY_LOGO](action, payload: string) {
        action.commit(types.COMPANY_LOGO, payload);
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: S E T T I N G S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    [types.SETTINGS_MYSETTING_LOAD](action){
        return api.getMySetting()
            .then((res: gnb.CM_MySetting) => {
                action.commit(types.SETTINGS_MYSETTING_LOAD, res);
                return res;
            })
    },

    [types.SETTINGS_MYSETTING_SAVE](action, payload: { data: gnb.CM_MySetting, isFirst: boolean }){        
        const { data, isFirst } = payload;
        // 처음 환경설정을 하는 경우
        if(isFirst){
            return api.createMySetting(data)
                .then((res) => {
                    action.dispatch(types.SETTINGS_MYSETTING_LOAD);
                    return res;
                });
        }
        // 환경설정을 수정하는 경우
        else{
            return api.setMysetting(data)
                .then((res) => {
                    action.dispatch(types.SETTINGS_MYSETTING_LOAD);
                    return res;
                });
        }
    },

    [types.APPLICATION_LIST_LOAD](action, payload: { comCode: string, personCode?: string }){
        const { comCode, personCode } = payload;
        api.getApplicationList(comCode, personCode)
            .then((res: gnb.CM_ApplicationList) => {
                console.log('APPLICATION_LIST_LOAD', res);
                action.commit(types.APPLICATION_LIST_LOAD, res);
            });
    },
    
    [types.APPLICATION_SELECTLIST_LOAD](action, payload: {comCode: string}) {
        const { comCode } = payload;
        return api.getApplicationSelectList(comCode)
        .then((res) => {
            action.commit(types.APPLICATION_SELECTLIST_LOAD, res);
            return res;
        })
    },

    [types.SETTINGS_DELEGATOR_LIST_LOAD](action, personCode: string) {
        return api.getDelegationList(personCode)
            .then((res: gnb.CM_DelegationList) => {
                action.commit(types.SETTINGS_DELEGATOR_LIST_LOAD, res);
                return res;
            })
    },

    
    [types.SETTINGS_DELEGATOR_ADD](action, payload: gnb.CM_DelegationItem) {
        const { delegation } = payload;
        return api.setDelegator(delegation)
            .then((res: boolean) => {
                if(res){
                    action.dispatch(types.SETTINGS_DELEGATOR_LIST_LOAD, delegation.personCode);
                }
                return res;
            });
    },

    [types.SETTINGS_DELEGATOR_REMOVE](action, payload: gnb.CM_DelegationItem) {
        const { delegation } = payload;
        const { seq, personCode } = delegation;
        
        return api.removeDelegator({ Seq: seq, DeleteFlag: true })
            .then((res: boolean) => {
                if(res){
                    action.dispatch(types.SETTINGS_DELEGATOR_LIST_LOAD, personCode);
                }
                return res;
            })
    },

    [types.APPLICATION_SELECTLIST_LOAD](action, payload: {comCode: string}) {
        const { comCode } = payload;
        return api.getApplicationSelectList(comCode)
        .then((res) => {
            action.commit(types.APPLICATION_SELECTLIST_LOAD, res);
            return res;
        })
    },

    [types.APPOPTIONLIST_LOAD](action, payload: gnb.RequestWorkflowOption){
        var current = store?.getters['$account/current'] as account.TCurrent;
        return api.getApplicationOptionList(current.cacheVersion.workflow, current.user.comCode)
            .then((res: gnb.CM_ApplicationOption) => {
                var list = res.optionList.map(x => {
                    return {
                        ...x,
                        optionValues: x.optionValues.map(y => {
                            return {
                                ...y,
                                isCommon: y.applicationId === undefined || y.applicationId === null
                            }
                        })
                    }
                }).filter(y => y.optionItem.typeId == payload.typeId);
                res.optionList = list;
                return res;
            });
    },

    //
    // ────────────────────────────────────────────────────────────────────── I ──────────
    //   :::::: L A N G U A G E A N D T I M E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────────────────
    //
    
    [types.LANGUAGE_LOAD](action) {
        action.commit(types.LANGUAGE_LOAD);
    },

    [types.TIME_LOAD](action) {
        action.commit(types.TIME_LOAD);
    },

    [types.LANGUAGE_TIME_CHANGE](action, item: gnb.UserConfig) {
       return api.setUserConfig(item);
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: U S E R C A R D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    [types.DOWNLOAD_PC](action, item: gnb.downloadOption): Promise<any> {
        return api.checkDownloadEml(item).then(checkResult => {
            if (checkResult.succeed) {
                return api
                    .downloadPC(item)
                    .then(() => {
                        return checkResult;
                    })
                    .catch((err) => {
                        (window as any).alertAsync(i18n.t('M_Settings_Msg43'));
                        return checkResult;
                    });
            }
            else {
                const { succeed, resultCode, exception, maxSize, transitionSize } = checkResult;
                const readablizeBytes = (bytes: number) => {
                    var s = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
                    var e = Math.floor(Math.log(bytes) / Math.log(1024));
                    return (bytes / Math.pow(1024, e)) + ' ' + s[e];
                };
                const nMaxSize = readablizeBytes(maxSize);
                const nTransitionSize = readablizeBytes(transitionSize);
                switch (resultCode) {
                    case 'MaximumSizeExceeded':
                        (window as any).alertAsync(i18n.t('M_Mail_ArchiveErrorMaximumSizeExceeded', { size: nMaxSize }).toString());
                        break;

                    case 'SwitchLargeCapacity':
                        (window as any).alertAsync(i18n.t('M_Mail_ArchiveErrorSwitchLargeCapacity', { size: nTransitionSize }).toString());
                        break;
                }
                return checkResult;
            }
        });
    },
    
    [types.CARDSETTINGS](action): Promise<gnb.CardResponse> {
        return api.getUserBusinessCardInfo().then(res => {
            action.commit(types.CARDSETTINGS, res);
            return res;
        });
    },

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: Y A S K A W A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.WISENUT_SEARCH](action, payload: { keyWord: string, page: number, size: number }) {
        const { keyWord, page, size } = payload;
        let wisenutSearch = new WisenutSearch();
        let startCount = (page - 1) * size;

        return wisenutSearch.search({
            query: keyWord,
            sort: 'RANK/DESC',
            listCount: size,
            startCount: startCount
        }, 'board').then((res: Array<wisenut.SearchResultItem<wisenut.WisenutResponseItem>>) => {
            if (res && res.length > 0) {
                let articleList: gnbarticle.Article[] = res[0].documentSet.map(item => {
                    return {
                        articleId: item.articleId.toString(),
                        articleStatus: item.articleStatus,
                        attachFilesList: item.attachFiles.split('|'),
                        attachFiles: item.attachFiles,
                        boardId: item.boardId.toString(),
                        boardName: item.boardName,
                        boardName_En: item.boardNameEn,
                        boardName_Ch: item.boardNameCh,
                        boardName_Jp: item.boardNameJp,
                        content: item.content,
                        createdDate: IEDate(item.createdDate).toString(),
                        createdDeptName: item.createdDeptName,
                        createdDeptName_En: item.createdDeptNameEn,
                        createdDeptName_Ch: item.createdDeptNameCh,
                        createdDeptName_Jp: item.createdDeptNameJp,
                        createdMailAddress: item.createdMailAddress,
                        createdUser: item.createdUser,
                        createdUserName: item.createdUserName,
                        createdUserName_En: item.createdUserNameEn,
                        createdUserName_Ch: item.createdUserNameCh,
                        createdUserName_Jp: item.createdUserNameJp,
                        fieldvalues: item.fieldValues,
                        fileCode: item.fileCode,
                        fileContent: item.attach,
                        imageFilePath: item.imageFilePath,
                        menuPath: item.menuPath,
                        tags: item.tags,
                        title: item.title,
                        updatedDate: IEDate(item.updatedDate).toString(),
                        viewCount: item.viewCount.toString(),
                    } as gnbarticle.Article
                });

                let articleCount = res[0].totalCount;
                return { articleList: articleList, articleCount: articleCount };
            }
            else{
                return { articleList: [], articleCount: 0 };
            }
        }).catch((err) => {
            console.error('Wisenut Search Error:', err);
            return { articleList: [], articleCount: 0 };
        });
    }
};
